/**
 * @generated SignedSource<<212a488af5a7302d89275f6f6c17f4a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HubSpotAnalyticsEvent = "CREATED_FIRST_ORGANIZATION_APP" | "CREATED_FIRST_PERSONAL_APP" | "CREATED_ORGANIZATION" | "CREATED_ORGANIZATION_APP" | "CREATED_PERSONAL_APP" | "SYNCED_USER_COLLECTION" | "%future added value";
export type HubSpotAnalyticsEventMetadata = {
  appDataEvent?: AppDataProperties | null;
  appEvent?: AppProperties | null;
  organizationEvent?: OrganizationProperties | null;
};
export type AppProperties = {
  appId: string;
  appName?: string | null;
  appSlug?: string | null;
  organizationId?: string | null;
  organizationSlug?: string | null;
  userId?: string | null;
};
export type AppDataProperties = {
  appId: string;
  collection?: string | null;
  userId?: string | null;
};
export type OrganizationProperties = {
  organizationId: string;
  organizationSlug?: string | null;
};
export type useAnalyticsHoseMutation$variables = {
  event: HubSpotAnalyticsEvent;
  meta?: HubSpotAnalyticsEventMetadata | null;
};
export type useAnalyticsHoseMutation$data = {
  readonly pushAnalyticsEvent: {
    readonly ok: boolean;
  };
};
export type useAnalyticsHoseMutation = {
  response: useAnalyticsHoseMutation$data;
  variables: useAnalyticsHoseMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "event"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meta"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "event",
        "variableName": "event"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "meta"
      }
    ],
    "concreteType": "Response",
    "kind": "LinkedField",
    "name": "pushAnalyticsEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAnalyticsHoseMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAnalyticsHoseMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1049d5643879640e9c9fb7856bb1c42e",
    "id": null,
    "metadata": {},
    "name": "useAnalyticsHoseMutation",
    "operationKind": "mutation",
    "text": "mutation useAnalyticsHoseMutation(\n  $event: HubSpotAnalyticsEvent!\n  $meta: HubSpotAnalyticsEventMetadata\n) {\n  pushAnalyticsEvent(event: $event, metadata: $meta) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "52a6d924c87af57ad42111f26b175ecf";

export default node;
